<template>
	<v-card tile elevation="0" style="height: 100%; overflow-y: hidden">
		<v-card-title class="text-left card-header fixed-card-title2">
			<v-row no-gutters>
				<v-col cols="6">
					<v-toolbar-title>{{ $t('edit') }} {{ $t('item-catalog') }}</v-toolbar-title>
				</v-col>
				<v-spacer />
				<v-icon color="white" @click="closeDrawer">mdi-close</v-icon>
			</v-row>
		</v-card-title>
		<v-card-text class="pa-4 pb-0 overflow-y-auto" style="height: calc(100vh - 122px)">
			<v-row dense>
				<v-col cols="12">
					<v-text-field v-model="editingItemCatalog.name" :label="$t('name')" dense outlined hide-details />
				</v-col>
				<v-col cols="12">
					<v-text-field
						v-model="editingItemCatalog.manufacturer"
						:label="$t('manufacturer')"
						dense
						outlined
						hide-details />
				</v-col>
				<v-col cols="12">
					<v-text-field
						v-model="editingItemCatalog.modelNumber"
						:label="$t('model-number')"
						dense
						outlined
						hide-details />
				</v-col>
				<v-col cols="12">
					<v-select
						v-model="editingItemCatalog.category"
						:label="$t('category')"
						:items="categories"
						item-text="description"
						item-value="code"
						dense
						outlined
						hide-details
						:menu-props="{ offsetY: true }" />
				</v-col>
				<v-col cols="12">
					<v-text-field
						v-model="editingItemCatalog.defaultWarrantyMonths"
						:label="$t('warranty-length')"
						:suffix="$t('months')"
						dense
						outlined
						@keypress="(e) => /[0-9]/.test(e.key) || e.preventDefault()"
						hide-details />
				</v-col>
				<v-col cols="12">
					<v-text-field
						v-model="editingItemCatalog.defaultLifetimeMonths"
						:label="$t('lifetime-length')"
						:suffix="$t('months')"
						dense
						outlined
						@keypress="(e) => /[0-9]/.test(e.key) || e.preventDefault()"
						hide-details />
				</v-col>
				<v-col cols="12">
					<v-textarea v-model="editingItemCatalog.notes" :label="$t('notes')" dense outlined hide-details no-resize />
				</v-col>
			</v-row>
		</v-card-text>
		<v-container class="px-4">
			<v-row dense>
				<v-col cols="6" order="1">
					<v-btn elevation="0" class="cancel-button-style capitalize-text" @click="closeDrawer">
						{{ $t('cancel') }}
					</v-btn>
				</v-col>
				<v-col cols="6" order="2">
					<v-btn block color="primary" :disabled="!canSave" @click="save">{{ $t('save') }}</v-btn>
				</v-col>
			</v-row>
		</v-container>
	</v-card>
</template>
<script>
import { mapActions, mapState } from 'vuex';
export default {
	name: 'EditInventoryItemCatalog',
	data () {
		return {
			editingItemCatalog: {
				name: '',
				manufacturer: '',
				modelNumber: '',
				category: '',
				defaultWarrantyMonths: null,
				defaultLifetimeMonths: null,
				notes: '',
			},
		};
	},
	computed: {
		...mapState({
			selectedItemCatalog: (state) => state.inventoryItemCatalogs.selectedItemCatalog,
			categories: (state) => state.inventoryItemCatalogs.itemCategoryOptions,
		}),
		canSave () {
			return (
				this.editingItemCatalog.name.trim() &&
				this.editingItemCatalog.manufacturer.trim() &&
				this.editingItemCatalog.modelNumber.trim() &&
				this.editingItemCatalog.category.trim() &&
				Number(this.editingItemCatalog.defaultWarrantyMonths) > 0 &&
				Number(this.editingItemCatalog.defaultLifetimeMonths) > 0
			);
		},
	},
	async mounted () {
		this.editingItemCatalog = { ...this.selectedItemCatalog };
		if (!this.categories?.length) {
			await this.getInventoryItemCategoryOptions();
		}
	},
	methods: {
		...mapActions({
			getInventoryItemCategoryOptions: 'inventoryItemCatalogs/getInventoryItemCategoryOptions',
			getItemCatalogs: 'inventoryItemCatalogs/getItemCatalogs',
			editItemCatalog: 'inventoryItemCatalogs/editItemCatalog',
		}),
		closeDrawer () {
			this.editingItemCatalog = {
				name: '',
				manufacturer: '',
				modelNumber: '',
				category: '',
				defaultWarrantyMonths: null,
				defaultLifetimeMonths: null,
				notes: '',
			};
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', false);
		},
		async save () {
			this.editingItemCatalog.defaultLifetimeMonths = Number(this.editingItemCatalog.defaultLifetimeMonths);
			this.editingItemCatalog.defaultWarrantyMonths = Number(this.editingItemCatalog.defaultWarrantyMonths);
			await this.editItemCatalog(this.editingItemCatalog);
			await this.getItemCatalogs();
			this.closeDrawer();
		},
	},
	watch: {
		selectedItemCatalog (newVal) {
			this.editingItemCatalog = { ...newVal };
		},
	},
};
</script>
